import { Box } from '@freighthub/silhouette-core'
import { FC } from 'react'
import { useAuth } from 'service/useAuth'
import { useI18n } from 'utils/localisation'

import { IQuoteSheet } from '../QuoteSheetModel'
import { usePdfDownloadMode } from '../usePdfDownloadMode'

interface RequestInfoProps {
  quoteSheet: IQuoteSheet
}

export const RequestInfo: FC<RequestInfoProps> = ({ quoteSheet }) => {
  const {
    state: { customer: currentCustomer },
  } = useAuth()
  const { translate } = useI18n()
  const { isPdfDownloadMode } = usePdfDownloadMode()

  const manualQuoteRequest = quoteSheet?.request?.manualQuoteRequest
  // make sure customers are matching before displaying the customer name
  const customer = quoteSheet?.request?.customerId === currentCustomer._id ? currentCustomer : null

  if (!isPdfDownloadMode || !manualQuoteRequest) {
    return null
  }

  return (
    <Box
      display="flex"
      marginBottom={-1}
      padding={1}
      justifyContent="space-between"
      borderBottom={1}
      sx={(theme) => ({
        borderColor: theme.palette.divider,
        color: theme.palette.text.secondary,
        fontSize: theme.typography.subtitle2.fontSize,
      })}
    >
      <div>{customer?.name || customer?._id || ''}</div>
      <div>
        {translate('quotes-quotes_card-quote_reference_header')}: {manualQuoteRequest.id}
      </div>
    </Box>
  )
}
